import script from "./AppRadio.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppRadio.vue?vue&type=script&setup=true&lang=ts"

import "./AppRadio.vue?vue&type=style&index=0&id=f742b6ba&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f742b6ba"]])

export default __exports__